/** Portal list pages that accept a preselected domain via location state, by trigger model. */
export const LIST_ROUTE_BY_MODEL: Record<string, string> = {
  'sale.order': '/outbound',
  'purchase.order': '/warehouse/inbound',
  'stock.picking': '/returns',
  'product.product': '/warehouse/inventory',
  'project.task': '/cases',
};

export const recordListDomain = (ids: number[]): string => `[("id", "in", [${ids.join(', ')}])]`;
